import {
  LetterbookUserBookReadType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import UserBookReadDetailsContent from "./UserBookReadDetailsContent";

export default function UserBookReadDetailsColumn({
  letterbook,
}: {
  letterbook: LetterbookUserBookReadType;
}) {
  return <UserBookReadDetailsContent letterbook={letterbook} />;
}

export const settings = {
  key: "UserBookReadDetails",
  title: "Details",
} as LetterlistTableColumnSettingType;
